import type { ReactNode } from "react";
import { useNavigate } from "react-router";
import { IconButton } from "../../components/ui/Button";
import { IconBack } from "../../components/icons";
import { PageFrame } from "../../app/PageFrame";

/** Compact sticky header for secondary pages. */
export function PageHeader({ title, subtitle, back = true, actions }: { title: ReactNode; subtitle?: ReactNode; back?: boolean; actions?: ReactNode }) {
  const navigate = useNavigate();
  return (
    <header className="sticky top-0 z-20 flex h-14 shrink-0 items-center gap-2 border-b border-line bg-bg/85 px-2 backdrop-blur-xl">
      {back && <IconButton label="Back" icon={IconBack} onClick={() => (window.history.length > 1 ? navigate(-1) : navigate("/feed"))} />}
      <div className={back ? "min-w-0 flex-1" : "min-w-0 flex-1 pl-2"}>
        <h1 className="truncate text-lg font-semibold leading-tight text-fg">{title}</h1>
        {subtitle && <div className="truncate text-xs text-fg-3">{subtitle}</div>}
      </div>
      {actions}
    </header>
  );
}

/** Standard page: responsive multi-column frame on desktop, single column on mobile. */
export function Column({ children }: { children: ReactNode }) {
  return <PageFrame>{children}</PageFrame>;
}

export function NotFoundPage() {
  const navigate = useNavigate();
  return (
    <div className="flex h-full flex-col items-center justify-center gap-3 p-6 text-center">
      <p className="text-5xl font-semibold tracking-tight text-fg-3 tabular">404</p>
      <h1 className="text-lg font-semibold">This page doesn't exist</h1>
      <button onClick={() => navigate("/feed")} className="h-9 rounded-md bg-surface-2 px-3.5 text-sm font-medium hover:bg-surface-3">
        Go to your feed
      </button>
    </div>
  );
}
